import {RD} from "../actionTypes"

const initialState = {
    chats: [],
    contacts: [],
    userProfile: {},
    selectedUser: {},
    rdChatWithBrands: null,
    rdContacts: [],
    // Per-tab contact lists — backend is source of truth, each fetch replaces the list
    inboxContacts: {data: []},
    sentContacts:  {data: []},
    archiveContacts: {data: []},
    unreadCounts: { inbox: 0, sent: 0, archive: 0 },
    selectedUserRdChat: {data: []},
    selectedUserRDChatLoading: false,
    selectedRdContactDetail: null,
    rdUserProfile: null,
    rdMessageTempletes: null,
    rdMessageResponse: null,
    rdContactLoadError: null,
    rdChatLoadError: null,
    activeTab: 'inbox'
}

const chatReducer = (state = initialState, action) => {
    switch (action.type) {

        case RD.CHAT_GET_USER_PROFILE_FROM_SERVER:
            return {
                ...state,
                rdUserProfile: action.rdUserProfile
            }

        case RD.CHAT_ADD_CONTACT: {
            // Prepend new contact to inbox
            const newInbox = [action.rdContact, ...(state.inboxContacts?.data || [])]
            return {
                ...state,
                inboxContacts: {data: newInbox}
            }
        }

        // Backend is the source of truth — replace the entire tab list on every fetch
        case RD.CHAT_CONTACTS: {
            const incoming = action.chatRdContacts?.data || action.chatRdContacts || []
            const tab = action.tab || 'inbox'
            const incomingUnreadCounts = action.chatRdContacts?.unread_counts || {
                inbox: action.chatRdContacts?.inbox_unread,
                sent: 0,
                archive: action.chatRdContacts?.archive_unread
            }

            const map = new Map()
            ;(incoming || []).forEach(item => {
                const key = item.chat_user || item.user_id
                if (key != null && !map.has(String(key))) {
                    map.set(String(key), item)
                }
            })
            const uniqueList = Array.from(map.values())

            const unreadCounts = incomingUnreadCounts.inbox !== undefined
                ? {
                    inbox: incomingUnreadCounts.inbox ?? state.unreadCounts.inbox,
                    sent: 0,
                    archive: incomingUnreadCounts.archive ?? state.unreadCounts.archive
                }
                : state.unreadCounts

            if (tab === 'sent') {
                return {...state, sentContacts: {data: uniqueList}, unreadCounts}
            }
            if (tab === 'archive') {
                return {...state, archiveContacts: {data: uniqueList}, unreadCounts}
            }
            // inbox (default)
            return {...state, inboxContacts: {data: uniqueList}, unreadCounts}
        }

        case RD.SET_ACTIVE_CHAT_TAB:
            return {
                ...state,
                activeTab: action.tab
            }

        case RD.ARCHIVE_CONVERSATION: {
            // Optimistic: remove from inbox and sent, add to archive
            const isTarget = (item) =>
                item.chat_user === action.otherUserId || item.user_id === action.otherUserId

            const itemToArchive = (state.inboxContacts?.data || []).find(isTarget)
                || (state.sentContacts?.data || []).find(isTarget)

            return {
                ...state,
                inboxContacts:   {data: (state.inboxContacts?.data  || []).filter(i => !isTarget(i))},
                sentContacts:    {data: (state.sentContacts?.data    || []).filter(i => !isTarget(i))},
                archiveContacts: {
                    data: itemToArchive
                        ? [{...itemToArchive, is_archived: 1}, ...(state.archiveContacts?.data || [])]
                        : (state.archiveContacts?.data || [])
                },
                selectedRdContactDetail: state.selectedRdContactDetail && isTarget(state.selectedRdContactDetail)
                    ? { ...state.selectedRdContactDetail, is_archived: 1 }
                    : state.selectedRdContactDetail
            }
        }

        case RD.UNARCHIVE_CONVERSATION: {
            const isTarget = (item) =>
                item.chat_user === action.otherUserId || item.user_id === action.otherUserId

            const itemToUnarchive = (state.archiveContacts?.data || []).find(isTarget)

            return {
                ...state,
                archiveContacts: {data: (state.archiveContacts?.data || []).filter(i => !isTarget(i))},
                inboxContacts: {
                    data: itemToUnarchive
                        ? [{...itemToUnarchive, is_archived: 0}, ...(state.inboxContacts?.data || [])]
                        : (state.inboxContacts?.data || [])
                },
                selectedRdContactDetail: state.selectedRdContactDetail && isTarget(state.selectedRdContactDetail)
                    ? { ...state.selectedRdContactDetail, is_archived: 0 }
                    : state.selectedRdContactDetail
            }
        }

        case RD.NEW_MESSAGE:
            state.selectedUserRdChat.data.push(action.message)
            return {...state}

        case RD.CHAT_SELECTED_CONTACT:
            return {
                ...state,
                selectedRdContactDetail: action.selectedRdContactDetail
            }

        case RD.LOAD_SELECTED_USER_CHAT:
            return {
                ...state,
                selectedUserRDChatLoading: action.selectedUserRDChatLoading
            }

        case 'GET_USER_PROFILE':
            return {
                ...state,
                userProfile: action.userProfile
            }

        case 'GET_CHAT_CONTACTS':
            return {
                ...state,
                chats: action.data.chatsContacts,
                contacts: action.data.contacts
            }

        case 'SELECT_CHAT':
            return {
                ...state,
                selectedUser: action.data
            }

        case 'SEND_MSG': {
            const newMsg = action.data.response.chat
            return {
                ...state,
                selectedUser: {...state.selectedUser, rdChatWithBrands: newMsg}
            }
        }

        case 'RECEIVE_NEW_CHAT_MESSAGE':
            return {
                ...state,
                selectedUser: {...state.selectedUser, chat: action.chat}
            }

        case 'CHAT_RD_WITH_BRANDS':
            return {
                ...state,
                rdChatWithBrands: action.rdChatWithBrands
            }

        case 'SELECT_CHAT_FROM_SERVER': {
            const incomingUser = action.selectedUserChat?.user
            return {
                ...state,
                selectedUserRdChat: action.selectedUserChat,
                selectedRdContactDetail: incomingUser
                    ? {
                        ...(state.selectedRdContactDetail || {}),
                        ...incomingUser,
                        is_archived: incomingUser.is_archived !== undefined
                            ? incomingUser.is_archived
                            : state.selectedRdContactDetail?.is_archived
                    }
                    : state.selectedRdContactDetail
            }
        }

        case 'SELECTED_CONTACT_DETAIL':
            return {
                ...state,
                selectedRdContactDetail: action.selectedContactDetail
            }

        case RD.CHAT_GET_MESSAGE_TEMPLETES:
            return {
                ...state,
                rdMessageTempletes: action.messageTemplete
            }

        case 'SEND_MSG_SUCCESS_RESPONSE_RD':
            return {
                ...state,
                rdMessageResponse: action.payload
            }

        case 'SEND_MSG_SUCCESS_RESPONSE_RD_NULL':
            return {
                ...state,
                rdMessageResponse: null
            }

        case 'CLEAR_RD_CHAT_COUNT_ON_CLICK': {
            const contact = action.payload
            const clearList = (list) => (list || []).map(item =>
                item.user_id === contact?.user_id || item.chat_user === contact?.chat_user
                    ? {...item, unread_messages: 0}
                    : item
            )
            const updatedInbox = clearList(state.inboxContacts?.data)
            const updatedArchive = clearList(state.archiveContacts?.data)
            return {
                ...state,
                inboxContacts:   {data: updatedInbox},
                sentContacts:    {data: clearList(state.sentContacts?.data)},
                archiveContacts: {data: updatedArchive},
                unreadCounts: {
                    inbox: updatedInbox.reduce((sum, c) => sum + (c.unread_messages || 0), 0),
                    sent: 0,
                    archive: updatedArchive.reduce((sum, c) => sum + (c.unread_messages || 0), 0)
                }
            }
        }

        case 'MARK_RD_CONVERSATION_UNREAD': {
            const otherUserId = action.payload || action.otherUserId
            const markList = (list) => (list || []).map(item =>
                item.user_id === otherUserId || item.chat_user === otherUserId || item.chatUser === otherUserId
                    ? {...item, unread_messages: (item.unread_messages || 0) + 1}
                    : item
            )
            const updatedInbox = markList(state.inboxContacts?.data)
            const updatedArchive = markList(state.archiveContacts?.data)
            return {
                ...state,
                inboxContacts:   {data: updatedInbox},
                sentContacts:    {data: markList(state.sentContacts?.data)},
                archiveContacts: {data: updatedArchive},
                unreadCounts: {
                    inbox: updatedInbox.reduce((sum, c) => sum + (c.unread_messages || 0), 0),
                    sent: 0,
                    archive: updatedArchive.reduce((sum, c) => sum + (c.unread_messages || 0), 0)
                }
            }
        }

        case 'RD_CONTACT_LOAD_ERROR':
            return {...state, rdContactLoadError: action.payload}

        case 'RD_CONTACT_LOAD_ERROR_RESET':
            return {...state, rdContactLoadError: null}

        case 'RD_CHAT_LOAD_ERROR':
            return {...state, rdChatLoadError: action.payload}

        case 'RD_CHAT_LOAD_ERROR_RESET':
            return {...state, rdChatLoadError: null}

        case 'RD_SELECTED_USER_CHAT_LOADER_RESET':
            return {...state, selectedUserRDChatLoading: false}

        default:
            return state
    }
}

export default chatReducer
